export default __webpack_public_path__ + "static/media/header-gateio.6900e492.svg";